/**
 * /map?lat=&lng=&zoom= 深連：從編輯頁跳回地圖定位。
 */
export function readMapFocusQuery(search = typeof location !== 'undefined' ? location.search : '') {
    const q = new URLSearchParams(search.startsWith('?') ? search : `?${search}`);
    const lat = parseFloat(q.get('lat'));
    const lng = parseFloat(q.get('lng'));
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
    const zoomRaw = parseInt(q.get('zoom') || '18', 10);
    return {
        lat,
        lng,
        zoom: Number.isFinite(zoomRaw) ? Math.min(Math.max(zoomRaw, 8), 20) : 18
    };
}

export function applyMapFocus(map, focus) {
    if (!map || !focus) return;
    map.setView([focus.lat, focus.lng], focus.zoom);
    if (typeof L === 'undefined') return;
    L.circleMarker([focus.lat, focus.lng], {
        radius: 11,
        color: '#50ff96',
        weight: 2,
        fillColor: '#50ff96',
        fillOpacity: 0.2
    }).addTo(map).bindPopup('編輯定位').openPopup();
}
